import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { getAllCustomers } from "../../../api/api";
import { SearchContext } from "../../../context/SearchContext";
import styles from "./ManageCustomer.module.css";
import Pagination from "../../../components/layout/Pagination/Pagination";

const ManageCustomer = () => {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const { searchTerm } = useContext(SearchContext);

  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    if (!token) {
      navigate("/login", {
        state: { error: "Session expired. Please log in again." },
      });
      return;
    }

    const fetchCustomers = async () => {
      try {
        const response = await getAllCustomers();
        setCustomers(response.data);
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };

    fetchCustomers();
  }, [navigate]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const filteredCustomers = customers.filter((customer) => {
    const q = (searchTerm || "").toLowerCase();
    return (
      (customer.name || "").toLowerCase().includes(q) ||
      (customer.email || "").toLowerCase().includes(q) ||
      (customer.phone || "").toLowerCase().includes(q) ||
      String(customer.id || "").toLowerCase().includes(q)
    );
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentCustomers = filteredCustomers.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleViewDetailsClick = (customer) => {
    navigate("/dashboard/customer-details", { state: { customer } });
  };

  return (
    <div className={styles.manageCustomer}>
      <div className={styles.buttonContainer}>
        <h2>Manage Customers</h2>
        <button className={styles.backButton} onClick={handleBackClick}>
          Back
        </button>
      </div>

      <table className={styles.customerTable}>
        <thead>
          <tr>
            <th>Customer ID</th>
            <th>Customer Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>View</th>
          </tr>
        </thead>
        <tbody>
          {filteredCustomers.length > 0 ? (
            currentCustomers.map((customer) => (
              <tr key={customer.id}>
                <td>{customer.id}</td>
                <td>{customer.name}</td>
                <td>{customer.email || "-"}</td>
                <td>{customer.phone || "-"}</td>
                <td>
                  <button
                    className={styles.viewDetailsButton}
                    onClick={() => handleViewDetailsClick(customer)}
                  >
                    View Details
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No customers found</td>
            </tr>
          )}
        </tbody>
      </table>

      {filteredCustomers.length > itemsPerPage && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}
    </div>
  );
};

export default ManageCustomer;
